import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";

import ThemeContext from "../context/ThemeContext";
import LanguageSelect from "./LanguageSelect";
import { toFixedWithoutRounding } from "../Utils/Toast";
import { t } from "i18next";
import { isMobile } from "react-device-detect";
// import useTawk from "../Pages/Tawk";

const HeaderComponent = () => {
  // const { openChat } = useTawk();
  const setSidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setSidebarModal;
  });
  const setProfileModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setProfileModal;
  });
  const refreshAmountLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.refreshAmountLoader;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const userCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.userCoins;
  });
  const theme = useContextSelector(ThemeContext, (ctx) => {
    return ctx.theme;
  });

  const [language, setLanguage] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const loc = location?.pathname?.split("/")[1];
  const getImageUrl = (url) => {
return url
  };
  return isMobile ? (
    <header
      id="header"
      className="normal-logo-left currency-inr ng-star-inserted"
    >
      <div className="header-left-btn-group">
        <div
          className="back-btn"
          style={{
            maskImage: 'url("/assets/Other/icon-arrow-type01.svg")',
          }}
        />
        <div
          onClick={() => setSidebarModal(true)}
          className="menu-btn ng-star-inserted"
        >
          <ul>
            <li />
            <li />
            <li />
          </ul>
        </div>
      </div>

      <div
        onClick={() => navigate("/")}
        className="logo"
        tabIndex={0}
        style={{
          backgroundImage:
            theme == "light"
              ? `url("/assets/Other/logo-light.png")`
              : `url("/assets/Other/logo.png")`,
        }}
      />

      {/* <div className="header-right-btn-group ng-star-inserted">
        {isEmpty(user) && (
          <div
            style={{ background: "transparent" }}
            onClick={() => setLanguage(true)}
            className="language-select"
          >
            <img alt="IN" src={"/assets/Other/BD.png"} loading="lazy" />
          </div>
        )}
      </div> */}

      <div _ngcontent-serverapp-c4244642973 className="header-right-btn-group">
        {" "}
        <a
          href="#"
          _ngcontent-serverapp-c4244642973
          className="service-btn ng-star-inserted"
          name="liveChatBtn"
        >
          <span
            _ngcontent-serverapp-c4244642973
            className="item-icon"
            style={{
              "mask-image":
                'url("/assets/NewIcon/header-appdownload-icon.svg")',
            }}
          />
          <p _ngcontent-serverapp-c4244642973 className="ng-star-inserted">
            {" "}
            App
          </p>
        </a>
        <a
          // onClick={() =>
          //   isEmpty(user) ? navigate("/login") : navigate("/customer-support")
          // }
          href="#"
          _ngcontent-serverapp-c4244642973
          className="service-btn ng-star-inserted"
          name="liveChatBtn"
        >
          <span
            _ngcontent-serverapp-c4244642973
            className="item-icon"
            style={{
              "mask-image":
                'url("/assets/NewIcon/header-customer-icon.svg?v=1776751585885")',
            }}
          />
          <p _ngcontent-serverapp-c4244642973 className="ng-star-inserted">
            {" "}
            LiveChat
          </p>
        </a>
      </div>
    </header>
  ) : (
    <app-header-desktop
      style={{ display: "block" }}
      _ngcontent-serverapp-c1218069548
      className="layout-desktop__header-inner ng-tns-c1218069548-2 layout-desktop__header-inner--shaded"
      _nghost-serverapp-c3097326535
    >
      <div
        _ngcontent-serverapp-c3097326535
        className="header-desktop currency-inr ng-star-inserted"
        id="header-desktop-1"
        style={{}}
      >
        <div _ngcontent-serverapp-c3097326535 className="header-desktop__inner">
          <div
            _ngcontent-serverapp-c3097326535
            className="header-desktop__main"
          >
            <div
              onClick={() => navigate("/")}
              _ngcontent-serverapp-c3097326535
              className="header-desktop__former"
            >
              <div
                _ngcontent-serverapp-c3097326535
                className="header-desktop__logo"
                tabIndex={0}
                style={{
                  backgroundImage:
                    theme == "light"
                      ? `url("/assets/Other/logo-light.png")`
                      : `url("/assets/Other/logo.png")`,
                }}
              />
            </div>
            <div
              _ngcontent-serverapp-c3097326535
              className="header-desktop__latter"
            >
              {" "}
              {isEmpty(user) ? (
                <div
                  _ngcontent-serverapp-c3097326535
                  className="header-desktop__item header-desktop__auth-container auth-container ng-star-inserted"
                >
                  <button
                    onClick={() =>
                      navigate("/login", { state: { background: location } })
                    }
                    _ngcontent-serverapp-c3097326535
                    className="auth-container__button auth-container__button--primary"
                    tabIndex={0}
                  >
                    {t("Login")}
                  </button>
                  <button
                    onClick={() =>
                      navigate("/register", { state: { background: location } })
                    }
                    _ngcontent-serverapp-c3097326535
                    id="register_btn"
                    className="auth-container__button auth-container__button--secondary"
                    tabIndex={0}
                  >
                    {t("SignUp")}
                  </button>
                </div>
              ) : (
                <>
                  <div
                    _ngcontent-serverapp-c3097326535=""
                    className="header-desktop__item header-desktop__deposit-label deposit-label ng-star-inserted"
                    id="depo_btn"
                    tabIndex="0"
                    onClick={() =>
                      navigate("/wallet/deposit", {
                        state: { background: location },
                      })
                    }
                  >
                    <div
                      _ngcontent-serverapp-c3097326535=""
                      className="deposit-label__deposit"
                      style={{
                        "background-image": `url(${getImageUrl(
                          "/assets/Icon/icon-deposit-web.svg",
                        )})`,
                      }}
                    />
                    <div
                      _ngcontent-serverapp-c3097326535=""
                      className="deposit-label__title"
                    >
                      {t("Deposit")}
                    </div>
                  </div>

                  {["/", "match-detail", "sports"].includes(loc) ? (
                    <>
                      <div
                        onClick={() => amounutRefresh()}
                        _ngcontent-serverapp-c3097326535
                        className="cricket-money ng-star-inserted"
                        style={{ fontSize: "medium" }}
                      >
                        <div
                          _ngcontent-serverapp-c3097326535
                          className={`icon-refresh ${
                            refreshAmountLoader ? "active" : ""
                          }`}
                          style={{
                            "mask-image":
                              'url("/assets/Icon/icon-refresh-type01.svg")',
                          }}
                        />
                        BDT
                        <span
                          style={{ marginLeft: "4px" }}
                          _ngcontent-serverapp-c3097326535
                        >
                          {toFixedWithoutRounding(userCoins?.totalCoins)}
                        </span>
                      </div>

                      <div
                        _ngcontent-serverapp-c3097326535
                        className="exp ng-star-inserted"
                        style={{ fontSize: "medium" }}
                      >
                        EXP{" "}
                        <span
                          style={{ marginLeft: "4px" }}
                          _ngcontent-serverapp-c3097326535
                        >
                          {" "}
                          ({toFixedWithoutRounding(userCoins?.exposure)})
                        </span>
                      </div>
                    </>
                  ) : (
                    <div
                      _ngcontent-serverapp-c3097326535=""
                      className={`header-desktop__item header-desktop__main-wallet-label main-wallet-label ng-star-inserted ${
                        refreshAmountLoader ? "main-wallet-label--clicked" : ""
                      }`}
                    >
                      <div
                        onClick={() => amounutRefresh()}
                        _ngcontent-serverapp-c3097326535=""
                        className={`main-wallet-label__refresh ${
                          refreshAmountLoader ? "active" : ""
                        }`}
                        style={{
                          maskImage: 'url("/assets/Other/refresh.svg")',
                        }}
                      />
                      <div
                        _ngcontent-serverapp-c3097326535=""
                        className="main-wallet-label__title"
                      >
                        {t("MainWallet")}
                      </div>
                      <div
                        _ngcontent-serverapp-c3097326535=""
                        className="main-wallet-label__value"
                      >
                        {" "}
                        ৳{toFixedWithoutRounding(userCoins?.totalCoins)}
                      </div>
                    </div>
                  )}
                  <div
                    onClick={() => setProfileModal(true)}
                    _ngcontent-serverapp-c3097326535=""
                    className="header-desktop__item header-desktop__user ng-star-inserted"
                    style={{
                      backgroundImage:
                        theme == "dark"
                          ? 'url("https://img.e491328.com/e28/h5/assets/images/desktop/header/icon-info.svg?v=1762247150189")'
                          : 'url("https://img.e491328.com/e28/h5/assets/images/light/desktop/header/icon-info.svg?v=1762247150189")',
                    }}
                  >
                    <span
                      _ngcontent-serverapp-c3097326535=""
                      className="header-desktop__item-bg ng-star-inserted"
                    >
                      <span
                        _ngcontent-serverapp-c3097326535=""
                        className="header-desktop__item-bg-notice"
                      >
                        {" "}
                        1{" "}
                      </span>
                    </span>
                  </div>
                </>
              )}
              <div
                onClick={() => setLanguage(true)}
                _ngcontent-serverapp-c3097326535
                className="header-desktop__item header-desktop__lang-switch"
              >
                <img
                  _ngcontent-serverapp-c3097326535
                  alt="IN"
                  src={"/assets/Other/BD.png"}
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-language
        _ngcontent-serverapp-c3097326535
        className="header-desktop-lang-switch-menu ng-tns-c3044725087-5 ng-star-inserted"
        _nghost-serverapp-c3044725087
      >
        {language && <LanguageSelect setLanguage={setLanguage} />}
      </app-language>
    </app-header-desktop>
  );
};

export default HeaderComponent;

const number = [50, 200, 300, 500, 985, 2000, 5000, 10000];
